import { memo, useState } from 'react'
import { Box, Flex, Skeleton } from '@chakra-ui/react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import '../../layout/components/header/styles/header.scss';
import DsrManageOrgLogosModule from '../dsr-draft/DsrManageOrgLogosModule';
import DsrPageSideMenuDrawer from "./DsrPageSideMenuDrawer";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { setIsShrunkHeader } from '../../global/actions/global-actions'
import { MdOutlineShare } from 'react-icons/md'
import { truncateMobileDsrTitle } from '../../global/helpers/global-helpers'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'


function DsrHeaderMobileDisplay({
  isEditMode,
  isSellingTeamMember,
  handleViewTeamMembers,
  currentDsrTitle,
  isArchivedDsr,
  // Action
  setIsShrunkHeader
}) {
  // Note: isMobileView is not required. This is already conditionally rendered only if it is mobile view
  const [isShrunk, setIsShrunk] = useState(false);
  const { openLaunchdeckModal } = useLaunchdeckModal();


  // Conditional styles for the banner
  const bannerStyles = {
    height: isShrunk ? '4em' : 'auto', // Shrinks height
    fontSize: isShrunk ? '0.875em' : '1.25em', // Shrinks font
    logoSize: isShrunk ? '2em' : '', // Shrinks logo
    transition: 'all 0.3s ease-in-out', // Smooth transition
    flexDirection: isShrunk ? 'row' : 'column',
    display: isShrunk ? 'flex' : 'block',
    alignItems: isShrunk ? 'left' : 'center',
  };

  const handleBannerClick = () => {
    setIsShrunk(!isShrunk)
    setIsShrunkHeader(!isShrunk)
  };

  const displayedTitle = currentDsrTitle ? truncateMobileDsrTitle(currentDsrTitle) : "";

  if (isEditMode) {
    // Currently do not allow users to edit drafts in mobile mode
    return null
  } else if (!!isArchivedDsr) {
    return (
      <>
        <Flex className='dsr-header__section'>
          <Flex className='dsr-header__container' alignItems='center'>
            <Flex justify='flex-start' align='center'>
              <Box display={['flex', 'none']}>
                <DsrPageSideMenuDrawer />
              </Box>
            </Flex>
          </Flex>
        </Flex>

        <Flex bg='brandPink.500' justify='center' color='white' fontSize='0.875em'>Room Archived</Flex>

        <Flex className='dsr-content__dsr-top-banner' py='1em'
          onClick={handleBannerClick} // Shrink on click
          height={bannerStyles.height}
          transition={bannerStyles.transition} // Smooth height transition
        >
          <Flex width='100%' justify={isShrunk ? 'flex-start' : 'center'} align={isShrunk && "center"} alignItems={isShrunk ? 'flex-start' : 'center'} p={!isShrunk && '0 1em'}>
            <Flex flexDirection={bannerStyles.flexDirection} alignItems={bannerStyles.alignItems} alignContent={'center'} >

              <DsrManageOrgLogosModule logoDisplayMode={'default-dsr'} logoSize={bannerStyles.logoSize} />

              {displayedTitle ?
                <Box
                  fontWeight='600'
                  lineHeight='1.875em' justify='flex-start' textAlign='center'
                  alignContent='center'
                  fontSize={bannerStyles.fontSize} // Dynamic font size
                  ml={isShrunk && '1em'}
                  className={isShrunk && 'truncate-long-text'}
                  maxW={isShrunk ? '15em' : '100%'}
                  whiteSpace={!isShrunk && 'pre-wrap'}
                >
                  {displayedTitle}
                </Box>
                : <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' width={["5em", "5em", "8em", "8em"]}></Flex></Skeleton>}
            </Flex>
          </Flex>
        </Flex>
      </>
    )
  } else {
    if (isSellingTeamMember === true) {
      const handleClickShareButton = () => {
        if (handleViewTeamMembers) {
          handleViewTeamMembers()
        } else {
          openLaunchdeckModal('view-team-members')
        }
      }
      return (
        <>
          <Flex className='dsr-header__section'>
            <Flex className='dsr-header__container' alignItems='center'>
              <Flex justify='flex-start' align='center'>
                <Box display={['flex', 'flex', 'none', 'none']}>
                  <DsrPageSideMenuDrawer />
                </Box>
                <Box
                  className="page-title"
                  fontSize={['1em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white' ml='1em'>
                  Manage Room
                </Box>
              </Flex>
              <Flex>

                <Box rounded='0.25em'>
                  <Box
                    onClick={() => handleClickShareButton()}
                    cursor='pointer'
                    p='0.1em'
                    bg='brand.500'
                    rounded='50%'
                    color='white'
                    boxSize='1.75em'
                    align='center'
                    alignContent='center'
                  >

                    <MdOutlineShare />

                  </Box>

                </Box>
              </Flex>
            </Flex>
          </Flex>

          <Flex className='dsr-content__dsr-top-banner' py='1em'
            onClick={handleBannerClick} // Shrink on click
            height={bannerStyles.height}
            transition={bannerStyles.transition} // Smooth height transition
          >
            <Flex width='100%' justify={isShrunk ? 'flex-start' : 'center'} align={isShrunk && "center"} alignItems={isShrunk ? 'flex-start' : 'center'} p={!isShrunk && '0 1em'}>
              <Flex flexDirection={bannerStyles.flexDirection} alignItems={bannerStyles.alignItems} alignContent={'center'} >

                <DsrManageOrgLogosModule logoDisplayMode={'default-dsr'} logoSize={bannerStyles.logoSize} />

                {displayedTitle ?
                  <Box
                    fontWeight='600'
                    lineHeight='1.875em' justify='flex-start' textAlign='center'
                    alignContent='center'
                    fontSize={bannerStyles.fontSize} // Dynamic font size
                    ml={isShrunk && '1em'}
                    className={isShrunk && 'truncate-long-text'}
                    maxW={isShrunk ? '15em' : '100%'}
                    whiteSpace={!isShrunk && 'pre-wrap'}
                  >
                    {displayedTitle}
                  </Box>
                  : <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' width={["5em", "5em", "8em", "8em"]}></Flex></Skeleton>}
              </Flex>
            </Flex>
          </Flex>
        </>
      )
    }
    else if (isSellingTeamMember === false) {
      return (
        <>
          <Flex className='dsr-header__section'>
            <Flex className='dsr-header__container' alignItems='center'>
              <Flex justify='flex-start' align='center'>
                <DsrPageSideMenuDrawer />
              </Flex>

              <Box rounded='0.25em'>
                <LaunchdeckButton width='100%' bg='brand.500' color='white' onClick={() => {
                  if (handleViewTeamMembers) {
                    handleViewTeamMembers()
                  } else {
                    openLaunchdeckModal('view-team-members')
                  }
                }} label='Share' />
              </Box>
            </Flex>
          </Flex>

          <Flex className='dsr-content__dsr-top-banner' py='1.5em'
            onClick={handleBannerClick} // Shrink on click
            height={bannerStyles.height}
            transition={bannerStyles.transition} // Smooth height transition
          >
            <Flex width='100%' justify={isShrunk ? 'flex-start' : 'center'} align={isShrunk && "center"} alignItems={isShrunk ? 'flex-start' : 'center'} p={!isShrunk && '0 1em'}>
              <Flex flexDirection={bannerStyles.flexDirection} alignItems={bannerStyles.alignItems} alignContent={'center'} >
                <Flex>
                  <DsrManageOrgLogosModule logoDisplayMode={'default-dsr'} />
                </Flex>
                {currentDsrTitle ?
                  <Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' justify='flex-start' textAlign='center'>
                    {currentDsrTitle}
                  </Flex>
                  : <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' width={["5em", "5em", "8em", "8em"]}></Flex></Skeleton>}
              </Flex>
            </Flex>
          </Flex>
        </>
      )
    } else {
      return null;
    }
  }

}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setIsShrunkHeader
    },
    dispatch,
  )

export default memo(withRouter(connect(null, mapDispatchToProps)(DsrHeaderMobileDisplay)))